export default {"src":"/_next/static/media/plus_64.f92197e1.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};